// extracted by mini-css-extract-plugin
export default {"container":"learning-section_container__UtCXj","content":"learning-section_content__pUwtK","text":"learning-section_text__EZuM4","buttons":"learning-section_buttons__X4vrv"};